import { inject, injectable, singleton } from 'tsyringe';
import { type ExtensionConfig, ExtensionContext } from "../common/models/extension-config";
import { Module } from "../common/module";
@singleton()
export class CommonModule extends Module {
    public name: string = 'CommonModule';
    public acceptedLicenseFlags: string[] = [];
    public shouldRun(context: ExtensionContext): boolean {
        return false;
    }
    constructor() {
        super([]);
    }



    public async run(): Promise<void> {

    }


    public isStandaloneVizQL(): boolean {
        if (window.stm.config.context !== ExtensionContext.vizql) {
            return false;
        }
        if (!window.parent || window.parent === window) {
            return true;
        }
        // try to get parent windows origin -> if its the same, we have vizportal above
        try {
            if (window.parent.location.origin === window.location.origin) {
                return false;
            }
        } catch (e) {
            // cannot get parent windows URL - no vizportal above
        }
        return true;
    }

    public wait(ms: number): Promise<void> {
        return new Promise<void>(r => setTimeout(() => r(), ms));
    }

    public combineUrl(...parts: string[]): string {
        return parts.filter(e => !!e).map((e, i) => {
            let r = e?.trim() ?? '';
            if (i !== 0 && r.startsWith('/')) {
                r = r.substring(1);
            }
            if (r.endsWith('/')) {
                r = r.substring(0, r.length - 1);
            }
            return r;
        }).join('/');

    }

    /**
     * Waits for a DOM element to appear in the specified inElement for maxSeconds.
     * @param selector The selector to look for
     * @param maxSeconds The maximum number of seconds to wait
     * @param inElement Use this element to search in
     * @returns The Element if successful, null if the element was not found in the specified number of seconds
     */
    public async waitForElement(selector: string, maxSeconds: number, inElement: Element | Document): Promise<Element | null> {
        let elapsed = 0;
        while (elapsed <= maxSeconds * 1000) {
            const ret = inElement.querySelector(selector);
            if (ret) {
                return ret;
            }
            await this.wait(500);
            elapsed += 500;
        }
        return null;
    }

    /**
     * Gets the Dashboard document. If we are in VizPortal, it returns the Dashboard vizql iframe document. If we are in VizQL, it returns the current document
     * @returns The HTMLDocument that contains the visualization
     */
    public async getDashboardDocument(waitSeconds: number = 60): Promise<Document | null> {
        const dashboardIframeSelector = `iframe[src^="${window.location.origin}"]`;
        switch (window.stm.config.context) {
            case ExtensionContext.vizql:
                return document;
            case ExtensionContext.vizportal:
                const iframe = await this.waitForElement(dashboardIframeSelector, waitSeconds, document.body);
                if (iframe === null) {
                    return null;
                }
                return (<HTMLIFrameElement>iframe).contentDocument;
        }
    }

    public getTableauApiVersion(): { major: number, minor: number } {
        const r = /^(\d+)\.(\d+)$/.exec(window.stm.config.serverVersion);
        if (!r || !r[1] || !r[2]) {
            throw new Error('Failed to parse tableau version');
        }
        return {
            major: +r[1],
            minor: +r[2]
        };
    }

    public downloadFile(dataUrl: string, name: string) {
        const link = document.createElement("a");
        link.download = name;
        link.href = dataUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    public requestAnimationFrame(): Promise<void> {
        return new Promise<void>(res => window.requestAnimationFrame(() => res()));
    }


    public queryElement(inEl: Element, selector: string): HTMLElement | undefined {
        return inEl.querySelector(selector) as HTMLElement;
    }
    public queryElements(inEl: Element, selector: string): HTMLElement[] {
        const ret: HTMLElement[] = [];
        inEl.querySelectorAll(selector).forEach(el => {
            const e = el as HTMLElement;
            if (e) {
                ret.push(e);
            }
        });
        return ret;
    }




}